export default __webpack_public_path__ + "static/media/materiaprima-03.84ad494f.jpg";